// =============================================================================
// FILE:
// frontend/src/modules/pms/material_logistics/pages/ReceiptWorkbenchListPage.js
// =============================================================================

import React, {
  useEffect,
  useState
} from "react";

import {
  RefreshCw
} from "lucide-react";

import {
  useNavigate
} from "react-router-dom";

import axiosClient
from "../../../../api/axiosClient";

import CommonWorkBenchDrawer
from "../components/CommonWorkBenchDrawer";

import {

  getReceiptList,

  createReceiptFromDispatch,

  getEligibleDispatchesForReceipt

} from "../services/materialReceiptService";

// =============================================================================
// COMPONENT
// =============================================================================

export default function ReceiptWorkbenchListPage() {

  // ===========================================================================
  // NAVIGATION
  // ===========================================================================
  const navigate =
    useNavigate();


  // ===========================================================================
  // STATE
  // ===========================================================================
  const [loading, setLoading] =
    useState(false);

  const [rows, setRows] =
    useState([]);

  const [error, setError] =
    useState("");

  const [filters, setFilters] =
    useState({

      status: "",

      search: ""
    });
    const [drawerOpen, setDrawerOpen] =
    useState(false);

    const [eligibleDispatches, setEligibleDispatches] =
    useState([]);

    const [drawerLoading, setDrawerLoading] =
    useState(false);


  // ===========================================================================
  // LOAD RECEIPTS
  // ===========================================================================
  const loadReceipts =
    async () => {

      try {

        setLoading(true);

        setError("");

        const response =
          await axiosClient.get(

            "/api/pms/material-receipt/list",

            {
              params: filters
            }
          );

        if (
          response?.data?.success
        ) {

          setRows(
            response.data.data || []
          );

        } else {

          setRows([]);
        }

      } catch (err) {

        console.error(err);

        setError(
          "Failed to load receipts"
        );

      } finally {

        setLoading(false);
      }
    };


  // ===========================================================================
  // INITIAL LOAD
  // ===========================================================================
  useEffect(() => {

    loadReceipts();

  }, []);


  // ===========================================================================
  // FILTER CHANGE
  // ===========================================================================
  const handleFilterChange = (
    field,
    value
  ) => {

    setFilters((prev) => ({

      ...prev,

      [field]: value
    }));
  };
// ===========================================================================
// LOAD ELIGIBLE DISPATCHES
// ===========================================================================

const loadEligibleDispatches =
  async () => {

    try {

      setDrawerLoading(true);

      const response =
        await getEligibleDispatchesForReceipt();

      if (response?.success) {

        setEligibleDispatches(

          response.data || []
        );

      } else {

        setEligibleDispatches([]);
      }

    } catch (err) {

      console.error(err);

      setEligibleDispatches([]);

    } finally {

      setDrawerLoading(false);
    }
  };

// ===========================================================================
// CREATE RECEIPT
// ===========================================================================
const handleCreateReceipt =
  async (dispatchId) => {

    try {

      const confirmed =
        window.confirm(

          "Create receipt from selected dispatch?"
        );

      if (!confirmed) {

        return;
      }

      setDrawerLoading(true);

      const response =
        await createReceiptFromDispatch({

          dispatch_header_id:
            dispatchId
        });

      if (response?.success) {

        alert(
          "Receipt created successfully"
        );

        // ---------------------------------------------------------------
        // REFRESH DRAWER
        // ---------------------------------------------------------------
        await loadEligibleDispatches();

        // ---------------------------------------------------------------
        // REFRESH MAIN GRID
        // ---------------------------------------------------------------
        await loadReceipts();

      } else {

        alert(

          response?.message ||

          "Failed to create receipt"
        );
      }

    } catch (err) {

      console.error(err);

      alert(

        err?.response?.data?.message ||

        "Failed to create receipt"
      );

    } finally {

      setDrawerLoading(false);
    }
  };  

  // ===========================================================================
  // APPLY FILTERS
  // ===========================================================================
  const handleApplyFilters =
    () => {

      loadReceipts();
    };


  // ===========================================================================
  // OPEN RECEIPT
  // ===========================================================================
  const openReceipt = (
    receiptId
  ) => {

    navigate(

      `/ipe/pms/material-receipt/${receiptId}`
    );
  };


  // ===========================================================================
  // KPI
  // ===========================================================================
  const kpis = {

    draft: rows.filter(
      (x) =>
        x.receipt_status === "DRAFT"
    ).length,

    received: rows.filter(
      (x) =>
        x.receipt_status ===
        "RECEIVED"
    ).length,

    submitted: rows.filter(
      (x) =>
        x.receipt_status ===
        "SUBMITTED"
    ).length,

    reconciled: rows.filter(
      (x) =>
        x.receipt_status ===
        "RECONCILED"
    ).length
  };


  // ===========================================================================
  // RENDER
  // ===========================================================================
  return (

    <div style={styles.page}>


      {/* ================================================================ */}
      {/* HEADER */}
      {/* ================================================================ */}
      <div style={styles.headerCard}>


        <div>

          <div style={styles.headerTitle}>

            Receipt Workbench

          </div>

          <div style={styles.headerSubtitle}>

            Execute material receipt
            and operational verification

          </div>

        </div>


        <div style={styles.headerActions}>


  <button
    style={styles.createBtn}
    onClick={() => {

  setDrawerOpen(true);

  loadEligibleDispatches();
}}
  >

    + Create Receipt

  </button>


  <button
    style={styles.refreshBtn}
    onClick={loadReceipts}
  >

    <RefreshCw size={16} />

    Refresh

  </button>

</div>

      </div>


      {/* ================================================================ */}
      {/* KPI SECTION */}
      {/* ================================================================ */}
      <div style={styles.kpiGrid}>


        <KPIBox
          title="Draft Receipts"
          value={kpis.draft}
          color="#2563eb"
        />

        <KPIBox
          title="Received"
          value={kpis.received}
          color="#0891b2"
        />

        <KPIBox
          title="Submitted"
          value={kpis.submitted}
          color="#ea580c"
        />

        <KPIBox
          title="Reconciled"
          value={kpis.reconciled}
          color="#16a34a"
        />

      </div>


      {/* ================================================================ */}
      {/* FILTER PANEL */}
      {/* ================================================================ */}
      <div style={styles.filterCard}>


        <div style={styles.filterGrid}>


          {/* ------------------------------------------------------------ */}
          {/* STATUS */}
          {/* ------------------------------------------------------------ */}
          <div>

            <div style={styles.label}>
              Receipt Status
            </div>

            <select

              style={styles.select}

              value={filters.status}

              onChange={(e) =>

                handleFilterChange(

                  "status",

                  e.target.value
                )
              }
            >

              <option value="">
                ALL
              </option>

              <option value="DRAFT">
                DRAFT
              </option>

              <option value="RECEIVED">
                RECEIVED
              </option>

              <option value="SUBMITTED">
                SUBMITTED
              </option>

              <option value="RECONCILED">
                RECONCILED
              </option>

            </select>

          </div>


          {/* ------------------------------------------------------------ */}
          {/* SEARCH */}
          {/* ------------------------------------------------------------ */}
          <div>

            <div style={styles.label}>
              Search Receipt
            </div>

            <input

              type="text"

              style={styles.input}

              placeholder="
                Search receipt/project/store
              "

              value={filters.search}

              onChange={(e) =>

                handleFilterChange(

                  "search",

                  e.target.value
                )
              }
            />

          </div>


          {/* ------------------------------------------------------------ */}
          {/* ACTION */}
          {/* ------------------------------------------------------------ */}
          <div style={styles.filterAction}>

            <button
              style={styles.applyBtn}
              onClick={
                handleApplyFilters
              }
            >

              Apply Filters

            </button>

          </div>

        </div>

      </div>


      {/* ================================================================ */}
      {/* ERROR */}
      {/* ================================================================ */}
      {

        error && (

          <div style={styles.errorBox}>

            {error}

          </div>
        )
      }


      {/* ================================================================ */}
      {/* GRID */}
      {/* ================================================================ */}
      <div style={styles.gridCard}>


        {/* -------------------------------------------------------------- */}
        {/* TABLE HEADER */}
        {/* -------------------------------------------------------------- */}
        <div style={styles.tableHeader}>


          <div style={styles.colReceipt}>
            Receipt
          </div>

          <div style={styles.colProject}>
            Project
          </div>

          <div style={styles.colStore}>
            Site Store
          </div>

          <div style={styles.colDispatch}>
            Dispatch
          </div>

          <div style={styles.colDate}>
            Date
          </div>

          <div style={styles.colStatus}>
            Status
          </div>

          <div style={styles.colAction}>
            Actions
          </div>

        </div>


        {/* -------------------------------------------------------------- */}
        {/* LOADING */}
        {/* -------------------------------------------------------------- */}
        {

          loading && (

            <div style={styles.placeholder}>

              Loading receipts...

            </div>
          )
        }


        {/* -------------------------------------------------------------- */}
        {/* EMPTY */}
        {/* -------------------------------------------------------------- */}
        {

          !loading &&
          rows.length === 0 && (

            <div style={styles.placeholder}>

              No receipts found

            </div>
          )
        }


        {/* -------------------------------------------------------------- */}
        {/* ROWS */}
        {/* -------------------------------------------------------------- */}
        {

          rows.map((row) => (

            <div
              key={row.id}
              style={styles.tableRow}
            >


              <div style={styles.colReceipt}>


                <div style={styles.mainText}>

                  {row.receipt_no}

                </div>


                <div style={styles.subText}>

                  Receipt:
                  {" "}

                  {row.receipt_date}

                </div>

              </div>


              <div style={styles.colProject}>

                {row.project_code || "-"}

              </div>


              <div style={styles.colStore}>

                {row.site_store_name || "-"}

              </div>


              <div style={styles.colDispatch}>

                {row.dispatch_no || "-"}

              </div>


              <div style={styles.colDate}>

                {row.receipt_date || "-"}

              </div>


              <div style={styles.colStatus}>


                <span style={
                  getStatusStyle(
                    row.receipt_status
                  )
                }>

                  {row.receipt_status}

                </span>

              </div>


              <div style={styles.colAction}>


                <button

                  style={styles.viewBtn}

                  onClick={() =>
                    openReceipt(row.id)
                  }
                >

                  👁

                </button>

              </div>

            </div>
          ))
        }

      </div>
      {/* ================================================================ */}
{/* CREATE RECEIPT DRAWER */}
{/* ================================================================ */}

<CommonWorkBenchDrawer

  open={drawerOpen}

  title="Create Receipt From Dispatch"

  onClose={() =>
    setDrawerOpen(false)
  }

  footer={

    <>

      <button

        style={styles.cancelBtn}

        onClick={() =>
          setDrawerOpen(false)
        }
      >

        Close

      </button>

    </>
  }
>


  {/* ============================================================== */}
  {/* PLACEHOLDER */}
  {/* ============================================================== */}
  <div>


  {/* ============================================================ */}
  {/* LOADING */}
  {/* ============================================================ */}
  {

    drawerLoading && (

      <div style={styles.drawerPlaceholder}>

        Loading approved dispatches...

      </div>
    )
  }


  {/* ============================================================ */}
  {/* EMPTY */}
  {/* ============================================================ */}
  {

    !drawerLoading &&
    eligibleDispatches.length === 0 && (

      <div style={styles.drawerPlaceholder}>

        No eligible dispatches found

      </div>
    )
  }


  {/* ============================================================ */}
  {/* GRID */}
  {/* ============================================================ */}
  {

    !drawerLoading &&
    eligibleDispatches.length > 0 && (

      <div style={styles.drawerGrid}>


        {/* ====================================================== */}
        {/* HEADER */}
        {/* ====================================================== */}
        <div style={styles.drawerTableHeader}>


          <div>Dispatch</div>

          <div>Project</div>

          <div>Site Store</div>

          <div>Vehicle</div>

          <div>Status</div>

          <div>Action</div>

        </div>


        {/* ====================================================== */}
        {/* ROWS */}
        {/* ====================================================== */}
        {

          eligibleDispatches.map((row) => (

            <div
              key={row.id}
              style={styles.drawerTableRow}
            >


              <div>

                {row.packing_list_no}

              </div>


              <div>

                {row.project_name || "-"}

              </div>


              <div>

                {row.site_store_name || "-"}

              </div>


              <div>

                {row.vehicle_no || "-"}

              </div>


              <div>

                <span style={styles.statusGreen}>

                  {

                    row.dispatch_status
                  }

                </span>

              </div>


              <div>

                <button

                style={styles.createReceiptBtn}

                onClick={() =>

                  handleCreateReceipt(
                    row.id
                  )
                }
              >

                Create Receipt

              </button>
              </div>

            </div>
          ))
        }

      </div>
    )
  }

</div>


</CommonWorkBenchDrawer>

    </div>
  );
}


// =============================================================================
// KPI BOX
// =============================================================================

function KPIBox({

  title,

  value,

  color

}) {

  return (

    <div
      style={{

        ...styles.kpiCard,

        borderTop:
          `4px solid ${color}`
      }}
    >

      <div style={styles.kpiTitle}>
        {title}
      </div>

      <div style={styles.kpiValue}>
        {value}
      </div>

    </div>
  );
}


// =============================================================================
// STATUS STYLE
// =============================================================================

function getStatusStyle(status) {

  switch (status) {

    case "RECONCILED":

      return styles.statusGreen;

    case "SUBMITTED":

      return styles.statusOrange;

    case "RECEIVED":

      return styles.statusBlue;

    default:

      return styles.statusGray;
  }
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  page: {

    padding: 20,

    background: "#f5f7fb",

    minHeight: "100vh"
  },

  headerCard: {

    background:
      "linear-gradient(90deg, #2563eb, #3b82f6)",

    borderRadius: 14,

    padding: "18px 22px",

    marginBottom: 20,

    color: "#fff",

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center"
  },

  headerTitle: {

    fontSize: 24,

    fontWeight: 700
  },

  headerSubtitle: {

    fontSize: 13,

    opacity: 0.92,

    marginTop: 4
  },

  headerActions: {

    display: "flex",

    gap: 10
  },

  refreshBtn: {

    display: "flex",

    alignItems: "center",

    gap: 8,

    background: "#fff",

    color: "#2563eb",

    border: "none",

    borderRadius: 8,

    padding: "10px 16px",

    fontWeight: 600,

    cursor: "pointer"
  },
createBtn: {

  background: "#111827",

  color: "#fff",

  border: "none",

  borderRadius: 8,

  padding: "10px 16px",

  fontWeight: 600,

  cursor: "pointer"
},

  kpiGrid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(220px, 1fr))",

    gap: 16,

    marginBottom: 20
  },

  kpiCard: {

    background: "#fff",

    borderRadius: 12,

    padding: 20,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  kpiTitle: {

    fontSize: 13,

    color: "#6b7280",

    marginBottom: 10
  },

  kpiValue: {

    fontSize: 34,

    fontWeight: 700,

    color: "#111827"
  },

  filterCard: {

    background: "#fff",

    borderRadius: 12,

    padding: 20,

    marginBottom: 20,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  filterGrid: {

    display: "grid",

    gridTemplateColumns:
      "1fr 2fr auto",

    gap: 16,

    alignItems: "end"
  },

  label: {

    fontSize: 13,

    color: "#374151",

    marginBottom: 6,

    fontWeight: 600
  },

  select: {

    width: "100%",

    border: "1px solid #d1d5db",

    borderRadius: 8,

    padding: "10px 12px"
  },

  input: {

    width: "100%",

    border: "1px solid #d1d5db",

    borderRadius: 8,

    padding: "10px 12px"
  },

  filterAction: {

    display: "flex",

    alignItems: "end"
  },

  applyBtn: {

    background: "#2563eb",

    color: "#fff",

    border: "none",

    borderRadius: 8,

    padding: "10px 16px",

    fontWeight: 600,

    cursor: "pointer"
  },

  errorBox: {

    background: "#fee2e2",

    color: "#b91c1c",

    padding: 14,

    borderRadius: 10,

    marginBottom: 20
  },

  gridCard: {

    background: "#fff",

    borderRadius: 12,

    padding: 20,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  tableHeader: {

    display: "grid",

    gridTemplateColumns:
      "1.8fr 1.5fr 1.5fr 1.2fr 1fr 1fr 0.7fr",

    gap: 16,

    padding: "14px 16px",

    background: "#f9fafb",

    border:
      "1px solid #e5e7eb",

    borderRadius: 10,

    fontSize: 13,

    fontWeight: 700,

    color: "#374151",

    marginBottom: 10
  },

  tableRow: {

    display: "grid",

    gridTemplateColumns:
      "1.8fr 1.5fr 1.5fr 1.2fr 1fr 1fr 0.7fr",

    gap: 16,

    padding: "14px 16px",

    border:
      "1px solid #e5e7eb",

    borderRadius: 10,

    alignItems: "center",

    background: "#fff",

    marginBottom: 10
  },

  colReceipt: {

    display: "flex",

    flexDirection: "column"
  },

  colProject: {

    display: "flex",

    alignItems: "center"
  },

  colStore: {

    display: "flex",

    alignItems: "center"
  },

  colDispatch: {

    display: "flex",

    alignItems: "center"
  },

  colDate: {

    display: "flex",

    alignItems: "center"
  },

  colStatus: {

    display: "flex",

    alignItems: "center"
  },

  colAction: {

    display: "flex",

    justifyContent: "center"
  },

  mainText: {

    fontWeight: 600,

    color: "#111827"
  },

  subText: {

    fontSize: 12,

    color: "#6b7280",

    marginTop: 4
  },

  placeholder: {

    padding: 40,

    textAlign: "center",

    color: "#6b7280"
  },

  viewBtn: {

    border:
      "1px solid #d1d5db",

    background: "#fff",

    borderRadius: 8,

    padding: "8px 12px",

    cursor: "pointer"
  },

  statusGray: {

    background: "#f3f4f6",

    color: "#374151",

    padding: "8px 14px",

    borderRadius: 20,

    fontSize: 12,

    fontWeight: 700
  },

  statusBlue: {

    background: "#dbeafe",

    color: "#1d4ed8",

    padding: "8px 14px",

    borderRadius: 20,

    fontSize: 12,

    fontWeight: 700
  },

  statusOrange: {

    background: "#ffedd5",

    color: "#c2410c",

    padding: "8px 14px",

    borderRadius: 20,

    fontSize: 12,

    fontWeight: 700
  },

  cancelBtn: {

  background: "#ffffff",

  color: "#111827",

  border: "1px solid #d1d5db",

  borderRadius: 8,

  padding: "10px 16px",

  fontWeight: 600,

  cursor: "pointer"
},

drawerPlaceholder: {

  background: "#ffffff",

  border:
    "1px dashed #d1d5db",

  borderRadius: 12,

  padding: 40,

  textAlign: "center",

  color: "#6b7280",

  fontSize: 14
},

drawerGrid: {

  display: "flex",

  flexDirection: "column",

  gap: 10
},

drawerTableHeader: {

  display: "grid",

  gridTemplateColumns:
    "1.5fr 1.5fr 1.5fr 1fr 1fr 1fr",

  gap: 16,

  padding: "14px 16px",

  background: "#f9fafb",

  border:
    "1px solid #e5e7eb",

  borderRadius: 10,

  fontSize: 13,

  fontWeight: 700,

  color: "#374151"
},

drawerTableRow: {

  display: "grid",

  gridTemplateColumns:
    "1.5fr 1.5fr 1.5fr 1fr 1fr 1fr",

  gap: 16,

  padding: "14px 16px",

  border:
    "1px solid #e5e7eb",

  borderRadius: 10,

  alignItems: "center",

  background: "#ffffff"
},

createReceiptBtn: {

  background: "#2563eb",

  color: "#ffffff",

  border: "none",

  borderRadius: 8,

  padding: "8px 12px",

  cursor: "pointer",

  fontWeight: 600
},
  statusGreen: {

    background: "#dcfce7",

    color: "#15803d",

    padding: "8px 14px",

    borderRadius: 20,

    fontSize: 12,

    fontWeight: 700
  }
};